(function(){
  "use strict";

  /* ---------- safe storage ---------- */
  var mem = {};
  function get(k){ try { var v = localStorage.getItem(k); return v === null ? (k in mem ? mem[k] : null) : v; } catch(e){ return (k in mem) ? mem[k] : null; } }
  function set(k,v){ mem[k] = v; try { localStorage.setItem(k,v); } catch(e){} }
  function del(k){ delete mem[k]; try { localStorage.removeItem(k); } catch(e){} }

  /* ---------- parts + nav ---------- */
  var PART_OF = {today:'today', setup:'today', why:'today',
                 disclosure:'program', safety:'program', plan:'program',
                 unlock:'program', reset:'program',
                 reminders:'progress', tracker:'progress', photos:'progress',
                 longer:'progress', feedback:'progress'};
  var prog = document.getElementById('prog');
  var links = [], secs = [];

  function rebuild(){
    var box = document.querySelector('.navlinks:not([hidden])');
    links = box ? Array.prototype.slice.call(box.querySelectorAll('a')) : [];
    secs  = links.map(function(a){ return document.querySelector(a.getAttribute('href')); })
                 .filter(Boolean);
  }

  function showPart(name, scroll){
    Array.prototype.forEach.call(document.querySelectorAll('.part'), function(el){
      el.hidden = (el.id !== 'part-' + name);
    });
    Array.prototype.forEach.call(document.querySelectorAll('.navlinks'), function(el){
      el.hidden = (el.getAttribute('data-links') !== name);
    });
    Array.prototype.forEach.call(document.querySelectorAll('.tab'), function(b){
      b.setAttribute('aria-selected', b.getAttribute('data-part') === name ? 'true' : 'false');
    });
    rebuild();
    var navIn = document.querySelector('.nav-in');
    if (navIn) navIn.hidden = (links.length === 0);
    if (scroll) {
      // 隐藏/显示刚改完，布局还没重算：等两帧，offsetTop 才是真值。
      // 页面已移除全局 scroll-behavior:smooth，所以这里是瞬时跳转。
      // 注意 .nav 是 sticky，粘住后它的 offsetTop 会跟着滚动走，不能当目标。
      var toTop = function(){
        var part = document.getElementById('part-' + name);
        var nav  = document.querySelector('.nav');
        var navH = nav ? nav.offsetHeight : 0;
        window.scrollTo(0, part ? Math.max(0, part.offsetTop - navH - 8) : 0);
        onScroll();
      };
      requestAnimationFrame(function(){ requestAnimationFrame(toTop); });
      setTimeout(toTop, 60);   // rAF 在后台/隐藏标签页会被暂停，这里兜底
    }
    onScroll();
  }

  Array.prototype.forEach.call(document.querySelectorAll('.tab'), function(b){
    b.addEventListener('click', function(){ showPart(b.getAttribute('data-part'), true); });
  });

  // 页内锚点统一走这里：必要时先切 tab，再定位，并让出 sticky 导航的高度
  function goTo(id){
    var el = document.getElementById(id);
    if (!el) return;
    var nav = document.querySelector('.nav');
    window.scrollTo(0, Math.max(0, el.offsetTop - (nav ? nav.offsetHeight : 0) - 10));
  }
  document.addEventListener('click', function(e){
    var a = e.target && e.target.closest ? e.target.closest('a[href^="#"]') : null;
    if (!a) return;
    var id = a.getAttribute('href').slice(1);
    if (!id) return;
    var part = PART_OF[id];
    if (!part) return;
    e.preventDefault();
    var host = document.getElementById('part-' + part);
    var switched = host && host.hidden;
    if (switched) showPart(part, false);
    setTimeout(function(){ goTo(id); }, switched ? 140 : 40);
  });
  Array.prototype.forEach.call(document.querySelectorAll('[data-goto]'), function(b){
    b.addEventListener('click', function(){
      showPart(b.getAttribute('data-goto'), true);
      var t = b.getAttribute('data-goto-target');
      if (t) setTimeout(function(){ goTo(t); }, 120);
    });
  });

  function routeHash(){
    var id = (location.hash || '').replace('#','');
    var part = PART_OF[id];
    if (part) {
      showPart(part, false);
      var el = document.getElementById(id);
      if (el) setTimeout(function(){ goTo(id); }, 60);
    }
  }
  window.addEventListener('hashchange', routeHash);

  function onScroll(){
    var h = document.documentElement;
    var max = h.scrollHeight - h.clientHeight;
    if (prog) prog.style.width = (max > 0 ? (h.scrollTop / max) * 100 : 0) + '%';
    var cur = null, y = h.scrollTop + 130;
    for (var i = 0; i < secs.length; i++){ if (secs[i].offsetTop <= y) cur = links[i]; }
    links.forEach(function(a){ a.classList.remove('on'); });
    if (cur) {
      cur.classList.add('on');
      var box = cur.parentNode;
      if (box.scrollWidth > box.clientWidth) {
        box.scrollTo({ left: cur.offsetLeft - (box.clientWidth/2) + (cur.offsetWidth/2), behavior:'smooth' });
      }
    }
  }
  window.addEventListener('scroll', onScroll, { passive:true });
  window.addEventListener('resize', onScroll);

  showPart('today', false);
  routeHash();
  onScroll();

  /* ---------- program clock (日期锚) ----------
     天数不存本地，从日期算。URL 的 ?start=YYYY-MM-DD 优先，
     所以换浏览器/换设备后“今天是第几天”依然正确。 */
  function pad2(n){ return (n < 10 ? '0' : '') + n; }
  function isoOf(d){ return d.getFullYear() + '-' + pad2(d.getMonth()+1) + '-' + pad2(d.getDate()); }
  function parseISO(v){
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(v || '');
    if (!m) return null;
    var d = new Date(+m[1], +m[2]-1, +m[3]);
    return isNaN(d.getTime()) ? null : d;
  }
  function midnight(d){ return new Date(d.getFullYear(), d.getMonth(), d.getDate()); }
  function dayDiff(a, b){ return Math.round((midnight(b) - midnight(a)) / 86400000); }
  function addDays(d, n){ var x = midnight(d); x.setDate(x.getDate() + n); return x; }

  var qStart = null;
  try { qStart = parseISO(new URLSearchParams(location.search).get('start')); } catch(e){}
  var sStart = parseISO(get('fg-pr-start'));
  var START  = qStart || sStart || midnight(new Date());
  if (qStart || !sStart) set('fg-pr-start', isoOf(START));

  var TODAY_ISO = isoOf(new Date());
  var DAY_IDX   = Math.max(1, dayDiff(START, new Date()) + 1);

  var PLAN = [
    null,
    { name:'Get familiar',   strap:'20–30 minutes, in one block',
      resets:0 },
    { name:'Add the reset',  strap:'Two blocks of about 20 minutes, with time off in between',
      resets:2 },
    { name:'More off than on', strap:'Up to about an hour total — 2–3 blocks, never in one go',
      resets:3 },
    { name:'Find your number', strap:'Your number — usually 30–60 minutes, split into blocks',
      resets:4 },
    { name:'Keep going',     strap:'Your number, ongoing — never past 2 hours a day',
      resets:3 }
  ];
  function weekOf(d){ return d > 30 ? 5 : Math.min(4, Math.ceil(d / 7)); }

  /* ---------- 30-day tracker (按 ISO 日期存) ---------- */
  var KEY  = 'fg-pr-done-v2';
  var grid = document.getElementById('grid');
  var done = {};
  try { done = JSON.parse(get(KEY) || '{}') || {}; } catch(e){ done = {}; }

  function dateOfCell(i){ return addDays(START, i - 1); }        // i: 1..30
  function isDone(iso){ return !!done[iso]; }

  function counts(){
    var n = 0, best = 0, run = 0;
    for (var i = 1; i <= 30; i++){
      if (isDone(isoOf(dateOfCell(i)))) { n++; run++; if (run > best) best = run; }
      else run = 0;
    }
    // 当前连续：从今天（或昨天，如果今天还没打）往回数
    var cur = 0, probe = midnight(new Date());
    if (!isDone(isoOf(probe))) probe = addDays(probe, -1);
    while (isDone(isoOf(probe)) && dayDiff(START, probe) >= 0){ cur++; probe = addDays(probe, -1); }
    return { n:n, best:best, cur:cur };
  }

  function renderToday(){
    var w = weekOf(DAY_IDX), p = PLAN[w];
    var dayEl = document.getElementById('tdDay');
    if (!dayEl) return;
    dayEl.textContent = DAY_IDX > 30 ? 'Day ' + DAY_IDX : 'Day ' + DAY_IDX + ' of 30';
    document.getElementById('tdWeek').textContent =
      (w > 4 ? 'Ongoing' : 'Week ' + w) + ' · ' + p.name;

    var li = ['<li><span class="ic">1</span><div><b>Morning Unlock</b> — about 4 minutes. '
            + '<a href="#unlock">Open it</a></div></li>'];
    if (p.resets > 0) li.push('<li><span class="ic">2</span><div><b>Desk Reset × ' + p.resets
            + '</b> — 90 seconds each, spread across your working day. '
            + '<a href="#reset">Open it</a></div></li>');
    li.push('<li><span class="ic">⌘</span><div><b>Strap:</b> ' + p.strap + '</div></li>');
    document.getElementById('tdList').innerHTML = li.join('');

    var dots = [];
    for (var i = 1; i <= 30; i++){
      var iso = isoOf(dateOfCell(i));
      dots.push('<i class="' + (isDone(iso) ? 'on' : '') + (i === DAY_IDX ? ' now' : '') + '"></i>');
    }
    document.getElementById('tdDots').innerHTML = dots.join('');

    var c = counts();
    var b = document.getElementById('btnMarkToday');
    var marked = isDone(TODAY_ISO);
    b.textContent = marked ? '✓ Done today' : 'Mark today done';
    b.className = 'btn' + (marked ? ' done-state' : '');

    document.getElementById('tdFoot').innerHTML =
      '<b>' + c.n + '</b> days done · <b>' + c.cur + '</b> day streak'
      + (c.best > c.cur ? ' · best <b>' + c.best + '</b>' : '')
      + '<br>Your ticks are saved in this browser only — open the page somewhere else and they start '
      + 'empty. That does not change what day you are on.';
  }

  function paint(){
    if (!grid) return;
    grid.innerHTML = '';
    for (var i = 1; i <= 30; i++){
      (function(idx){
        var d   = dateOfCell(idx);
        var iso = isoOf(d);
        var future = dayDiff(new Date(), d) > 0;
        var b = document.createElement('button');
        b.className = 'day' + (isDone(iso) ? ' done' : '') + (idx === DAY_IDX ? ' today' : '');
        b.textContent = idx;
        b.title = d.toDateString();
        b.setAttribute('aria-label', 'Day ' + idx + ' — ' + d.toDateString()
                       + (isDone(iso) ? ' — done' : ''));
        b.setAttribute('aria-pressed', isDone(iso) ? 'true' : 'false');
        if (future) { b.disabled = true; }
        else b.addEventListener('click', function(){
          if (done[iso]) delete done[iso]; else done[iso] = 1;
          set(KEY, JSON.stringify(done));
          paint(); stats(); renderToday();
        });
        grid.appendChild(b);
      })(i);
    }
  }

  function stats(){
    var c = counts();
    var a = document.getElementById('sDone');
    if (!a) return;
    a.textContent = c.n;
    document.getElementById('sStreak').textContent = c.cur;
    document.getElementById('sBest').textContent   = c.best;
  }

  paint(); stats(); renderToday();

  var mt = document.getElementById('btnMarkToday');
  if (mt) mt.addEventListener('click', function(){
    if (done[TODAY_ISO]) delete done[TODAY_ISO]; else done[TODAY_ISO] = 1;
    set(KEY, JSON.stringify(done));
    paint(); stats(); renderToday();
  });

  var bt = document.getElementById('btnToday');
  if (bt) bt.addEventListener('click', function(){
    done[TODAY_ISO] = 1;
    set(KEY, JSON.stringify(done)); paint(); stats(); renderToday();
  });
  var bc = document.getElementById('btnClear');
  if (bc) bc.addEventListener('click', function(e){
    e.preventDefault();
    if (window.confirm('Clear all your check-ins? This cannot be undone.')) {
      done = {}; del(KEY); paint(); stats(); renderToday();
    }
  });

  /* ---------- check-in scores ---------- */
  var ids = ['d1a','d1b','d15a','d15b','d30a','d30b'];
  var cmp = document.getElementById('cmp');

  function renderCmp(){
    var v = {};
    ids.forEach(function(id){ v[id] = document.getElementById(id).value; });
    var has = ids.some(function(id){ return v[id] !== ''; });
    if (!has) { cmp.innerHTML = "Fill in your numbers above and your comparison will appear here. They're saved in this browser only."; return; }
    function cell(x){ return x === '' ? '<span style="color:var(--ink-3)">—</span>' : x; }
    var delta = '';
    if (v.d1a !== '' && v.d30a !== ''){
      var d = Number(v.d1a) - Number(v.d30a);
      delta = d > 0 ? '<b>Tightness down ' + d + ' points</b> since day 1.'
            : d < 0 ? 'Tightness up ' + Math.abs(d) + ' points since day 1.'
            : 'Tightness unchanged since day 1.';
    }
    cmp.innerHTML =
      '<b>Your check-ins</b>' +
      '<table><tr><th></th><th>Day 1</th><th>Day 15</th><th>Day 30</th></tr>' +
      '<tr><td>Tightness (0–10)</td><td>' + cell(v.d1a) + '</td><td>' + cell(v.d15a) + '</td><td>' + cell(v.d30a) + '</td></tr>' +
      '<tr><td>Slouch catches / day</td><td>' + cell(v.d1b) + '</td><td>' + cell(v.d15b) + '</td><td>' + cell(v.d30b) + '</td></tr>' +
      '</table>' + (delta ? '<p style="margin:10px 0 0">' + delta + '</p>' : '');
  }

  ids.forEach(function(id){
    var el = document.getElementById(id);
    var saved = get('fg-pr-' + id);
    if (saved !== null) el.value = saved;
    el.addEventListener('input', function(){ set('fg-pr-' + id, el.value); renderCmp(); });
  });
  renderCmp();

  /* ---------- save to home screen / bookmark ---------- */
  var deferredPrompt = null;
  window.addEventListener('beforeinstallprompt', function(e){ e.preventDefault(); deferredPrompt = e; });

  function platform(){
    var ua = navigator.userAgent || '';
    var iOS = /iPad|iPhone|iPod/.test(ua) ||
              (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    if (iOS) return 'ios';
    if (/Android/i.test(ua)) return 'android';
    return /Mac/i.test(ua) ? 'mac' : 'win';
  }

  var panel = document.getElementById('saveinstr');

  // Facebook / Instagram / 微信等内置浏览器：存储与真实浏览器隔离，
  // 而且加不到主屏。先提示用户换成系统浏览器打开。
  function inAppBrowser(){
    var ua = navigator.userAgent || '';
    if (/FBAN|FBAV|FB_IAB/i.test(ua))   return 'the Facebook app';
    if (/Instagram/i.test(ua))          return 'the Instagram app';
    if (/MicroMessenger/i.test(ua))     return 'WeChat';
    if (/Line\//i.test(ua))             return 'LINE';
    if (/LinkedInApp/i.test(ua))        return 'the LinkedIn app';
    if (/Twitter|TwitterAndroid/i.test(ua)) return 'the X app';
    return null;
  }

  function showSave(){
    if (deferredPrompt) {                 // Android Chrome: real install prompt
      deferredPrompt.prompt();
      deferredPrompt = null;
      return;
    }
    var p = inAppBrowser() ? 'inapp' : platform();
    var app = inAppBrowser();
    var slot = panel.querySelector('.si[data-p="inapp"] .appname');
    if (slot && app) slot.textContent = app;
    Array.prototype.forEach.call(panel.querySelectorAll('.si'), function(el){
      el.hidden = (el.getAttribute('data-p') !== p);
    });
    panel.hidden = false;
    panel.scrollIntoView({ behavior:'smooth', block:'center' });
  }

  Array.prototype.forEach.call(document.querySelectorAll('[data-save]'), function(b){
    b.addEventListener('click', showSave);
  });

  var copyBtn = document.getElementById('btnCopy');
  if (copyBtn) copyBtn.addEventListener('click', function(){
    var msg = document.getElementById('copyMsg');
    var url = location.href;
    function ok(){ msg.textContent = 'Link copied.'; setTimeout(function(){ msg.textContent=''; }, 2500); }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(ok, fallback);
    } else { fallback(); }
    function fallback(){
      var t = document.createElement('textarea');
      t.value = url; t.setAttribute('readonly',''); t.style.position='fixed'; t.style.opacity='0';
      document.body.appendChild(t); t.select();
      try { document.execCommand('copy'); ok(); }
      catch(e){ msg.textContent = 'Copy the address from your browser bar.'; }
      document.body.removeChild(t);
    }
  });

  /* ---------- calendar (.ics) ---------- */
  function pad(n){ return (n < 10 ? '0' : '') + n; }
  function stampUTC(dt){
    return dt.getUTCFullYear() + pad(dt.getUTCMonth()+1) + pad(dt.getUTCDate()) + 'T' +
           pad(dt.getUTCHours()) + pad(dt.getUTCMinutes()) + pad(dt.getUTCSeconds()) + 'Z';
  }
  function localStart(base, hh, mm){
    var d = new Date(base.getFullYear(), base.getMonth(), base.getDate(), hh, mm, 0);
    if (d <= new Date()) d.setDate(d.getDate() + 1);
    return d.getFullYear() + pad(d.getMonth()+1) + pad(d.getDate()) + 'T' + pad(hh) + pad(mm) + '00';
  }
  function uid(){ return 'fg-' + Math.random().toString(36).slice(2) + '-' + Date.now() + '@fitgeno.com'; }

  function vevent(startLocal, rrule, summary, desc){
    return [
      'BEGIN:VEVENT',
      'UID:' + uid(),
      'DTSTAMP:' + stampUTC(new Date()),
      'DTSTART:' + startLocal,
      'DURATION:PT5M',
      'RRULE:' + rrule,
      'SUMMARY:' + summary,
      'DESCRIPTION:' + desc,
      'BEGIN:VALARM',
      'TRIGGER:PT0M',
      'ACTION:DISPLAY',
      'DESCRIPTION:' + summary,
      'END:VALARM',
      'END:VEVENT'
    ].join('\r\n');
  }

  document.getElementById('btnIcs').addEventListener('click', function(){
    var msg = document.getElementById('icsMsg');
    var mv = document.getElementById('tMorning').value || '07:30';
    var wv = document.getElementById('tWork').value || '09:00';
    var count = parseInt(document.getElementById('nReset').value, 10) || 3;

    var mh = parseInt(mv.split(':')[0], 10), mm = parseInt(mv.split(':')[1], 10);
    var wh = parseInt(wv.split(':')[0], 10), wm = parseInt(wv.split(':')[1], 10);
    var today = new Date();

    var parts = [
      'BEGIN:VCALENDAR',
      'VERSION:2.0',
      'PRODID:-//Fit Geno//Posture Reset//EN',
      'CALSCALE:GREGORIAN',
      'METHOD:PUBLISH'
    ];

    parts.push(vevent(
      localStart(today, mh, mm),
      'FREQ=DAILY;COUNT=30',
      'Posture Reset - Morning Unlock (4 min)',
      'Seated Wall Extension 15s x3 / Wall Lean 10s x3 / Towel Neck Release 10s x3 each side'
    ));

    var offsets = [2, 4, 6, 8];
    for (var i = 0; i < count; i++){
      var h = wh + offsets[i];
      if (h > 22) h = 22;
      parts.push(vevent(
        localStart(today, h, wm),
        'FREQ=WEEKLY;BYDAY=MO,TU,WE,TH,FR;COUNT=22',
        'Posture Reset - Desk Reset (90 sec)',
        'Chin Tuck 5s x10 / Behind-the-Back Clasp 30s x2 / Wall Chest Opener 5s x5 each side'
      ));
    }
    parts.push('END:VCALENDAR');

    var blob = new Blob([parts.join('\r\n')], { type:'text/calendar;charset=utf-8' });
    try {
      var url = URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url; a.download = 'fitgeno-posture-reset.ics';
      document.body.appendChild(a); a.click();
      document.body.removeChild(a);
      setTimeout(function(){ URL.revokeObjectURL(url); }, 1500);
      msg.textContent = 'Downloaded — open the file to add it.';
      msg.style.color = 'var(--accent)';
    } catch(e){
      msg.textContent = "Couldn't download here — try a different browser.";
      msg.style.color = 'var(--stop)';
    }
  });
})();
